(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};



	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup'); // Sticky bar
		const secondSection = document.querySelector('.product-section + section'); // Second section
		const footer = document.querySelector('footer'); // Footer

		// Check if the required elements exist
		if (!stickyBar || !secondSection || !footer) {
				console.error('Required elements not found!');
				return;
		}

			const getOffset = (element) => {
				const rect = element.getBoundingClientRect();
				return rect.top + window.scrollY;
			};

			const secondSectionMid = getOffset(secondSection);
			const footerTop = getOffset(footer);

			const handleScroll = () => {
				const scrollPosition = window.scrollY + window.innerHeight;
				const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;

				stickyBar.classList[activeOffset ? "add" : "remove"]('active');
			};

			// Initial check in case the user starts in the middle of the page
			handleScroll();
};

	document.addEventListener('scroll', () => revealPopup());


	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		revealPopup();
	});

	initProductAccordion();
	initZoomImage();
	revealPopup();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(`${this.getAttribute("data-product-url")}${window.location.search}`)
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		/*const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();*/

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);

// Size is not preselected on load, so block add to cart / stock in store until one is picked
(function () {
	const TOOLTIP_CLASS = "size-required-tooltip";
	const WRAPPER_CLASS = "size-required-tooltip-wrapper";
	const HIDE_DELAY = 4000;

	const isSizeSelected = (container) => {
		const idInput = container?.querySelector(
			'form[data-type="add-to-cart-form"] input[name="id"]'
		);
		return !idInput || idInput.value !== "";
	};

	const hideTooltips = () => {
		document.querySelectorAll(`.${TOOLTIP_CLASS}`).forEach((tooltip) => {
			clearTimeout(tooltip.hideTimer);
			tooltip.hidden = true;
		});
	};

	const showTooltip = (button) => {
		const wrapper = button.parentElement;
		let tooltip = wrapper.querySelector(`:scope > .${TOOLTIP_CLASS}`);

		if (!tooltip) {
			tooltip = document.createElement("div");
			tooltip.className = TOOLTIP_CLASS;
			tooltip.setAttribute("role", "alert");
			wrapper.classList.add(WRAPPER_CLASS);
			wrapper.insertBefore(tooltip, button);
		}

		hideTooltips();
		tooltip.textContent = window.variantStrings?.selectSize || "";
		tooltip.style.left = `${button.offsetLeft + button.offsetWidth / 2}px`;
		tooltip.style.top = `${button.offsetTop}px`;
		tooltip.hidden = false;
		tooltip.hideTimer = setTimeout(() => {
			tooltip.hidden = true;
		}, HIDE_DELAY);
	};

	const blockAction = (event, button) => {
		event.preventDefault();
		event.stopImmediatePropagation();
		showTooltip(button);
	};

	document.addEventListener(
		"submit",
		(event) => {
			const form = event.target;
			if (!form.matches('form[data-type="add-to-cart-form"]')) return;
			if (isSizeSelected(form)) return;

			const button = form.querySelector('[name="add"]');
			if (button) blockAction(event, button);
		},
		true
	);

	document.addEventListener(
		"click",
		(event) => {
			const button = event.target.closest("#rex-cnc-stockinstore");
			if (!button) return;

			const container = button.closest('[id^="ProductInfo-"], floated-form');
			if (isSizeSelected(container)) return;

			blockAction(event, button);
		},
		true
	);

	document.addEventListener("change", (event) => {
		if (event.target.closest("variant-radios, variant-selects")) hideTooltips();
	});

	// Runs before the add-to-cart submit re-shows it, and blocked clicks never bubble here
	document.addEventListener("click", hideTooltips);
})();

/* THF Custom css */

document.addEventListener('pointerup', function (e) {
  var openBtn = e.target.closest('.link-bnpl');
  if (openBtn) {
    e.preventDefault();

    var messageContainer = openBtn.closest('.bnpl-message-container');
    if (!messageContainer) return;

    var bnplBody = messageContainer.nextElementSibling;
    if (!bnplBody || !bnplBody.classList.contains('bnpl-body')) return;

    bnplBody.hidden = false;
    return;
  }

  var closeBtn = e.target.closest('.bnpl-close');
  if (closeBtn) {
    e.preventDefault();

    var bnplBody = closeBtn.closest('.bnpl-body');
    if (!bnplBody) return;

    bnplBody.hidden = true;
  }
}, { passive: false });
